import React from 'react';

import { Box } from '@chakra-ui/react';

import CreateGoalIllustration from 'assets/assetsV1/illustrations/newIllustrations/createGoal.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { ProgressBar } from 'uiToolkitV1/ProgressBar';
import { TextHeader1, TextLabel } from 'uiToolkitV1/Typography';

const Heading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" marginBottom="16px" width="100%">
    <TextHeader1 fontSize="20px" lineHeight="32px" fontWeight="600">
      Check-in update is in progress
    </TextHeader1>
  </Box>
);

const LoadingProgress = ({
  totalRecords = 1,
  recordsUpdated = 0,
}: {
  totalRecords: number;
  recordsUpdated: number;
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    padding="16px"
    flex="1"
    width="100%"
    border="1px dashed #CFD7DF"
    borderRadius="8px"
  >
    <Box display="flex" flexDir="column" gap="4px" flex="1">
      <ProgressBar
        value={totalRecords === 0 ? 0 : (recordsUpdated / totalRecords) * 100}
        backgroundColor="#EBEFF3"
        size="large"
        height="32px"
        color="linear-gradient(90deg, rgba(13, 129, 159, 0.24) 0%, #0D819F 171.86%)"
        text={undefined}
        textColor={undefined}
        textProps={undefined}
      />
      <TextLabel color="#666">
        Update completed for {recordsUpdated}/{totalRecords} goals
      </TextLabel>
    </Box>
  </Box>
);

export default function CheckInLoadingScreen({
  totalRecords,
  recordsUpdated,
}: {
  totalRecords: number;
  recordsUpdated: number;
}) {
  return (
    <Box width="360px">
      <EmptyScreen
        headerComp={Heading}
        illustrationSrc={CreateGoalIllustration}
        // eslint-disable-next-line react/no-unstable-nested-components
        descriptionComp={() => <LoadingProgress totalRecords={totalRecords} recordsUpdated={recordsUpdated} />}
      />
    </Box>
  );
}
